export default __webpack_public_path__ + "static/cabin-tiny-home-2-queens-4-ba4ef36ff7bdbb4af12b8e07a17c49c8.jpg";